import { sanitizeFileUrl } from "./filePreview.js";

/** Direkte Static-/uploads-Links (nicht guarded /api/.../uploads/...). */
export function isDirectUploadPath(url = "") {
  const raw = String(url || "").trim();
  if (!raw) return false;
  if (raw.startsWith("//")) return true;
  let pathname = raw.split("?")[0];
  try {
    if (/^https?:\/\//i.test(raw)) pathname = new URL(raw).pathname;
  } catch {
    return false;
  }
  const p = String(pathname || "").toLowerCase();
  if (p.startsWith("/api/")) return false;
  return p.startsWith("/uploads/");
}

/**
 * Kandidaten für Entity-Datei-URLs (ohne sanitize).
 * Policy: secure_* zuerst; Legacy public_url nur mit allowUnsafeLegacyPublicUrl und ohne /uploads-Pfad.
 */
export function pickEntityFileUrlRaw(row, { allowUnsafeLegacyPublicUrl = false } = {}) {
  const candidates = [
    row?.secure_preview_url,
    row?.secure_download_url,
    row?.secure_url,
  ];
  if (allowUnsafeLegacyPublicUrl) {
    const pub = String(row?.public_url || "").trim();
    if (pub && !isDirectUploadPath(pub)) candidates.push(pub);
  }
  for (const candidate of candidates) {
    const value = String(candidate || "").trim();
    if (value) return value;
  }
  return "";
}

export function resolveEntityFileUrl(row, options = {}) {
  const raw = pickEntityFileUrlRaw(row, options);
  if (!raw) return "";
  return sanitizeFileUrl(raw);
}
